/* ============================================================
   X-PRODUCT — product page extras + cart upsells (vanilla JS)
   Companion to assets/x-product.css. Additive only: it does not
   touch theme.js internals; in radio-pill mode it mirrors the
   variant sync theme.js performs for dropdown mode.
   ============================================================ */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- 1. Image zoom lightbox ---------- */
  $all('[data-zoom-modal]').forEach(function (modal) {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;
    var thumbs = $all('[data-thumb-src]', gallery);
    var mainImg = $('[data-gallery-main] img', gallery);
    var zoomImg = $('[data-zoom-img]', modal);
    var prevBtn = $('[data-zoom-prev]', modal);
    var nextBtn = $('[data-zoom-next]', modal);

    /* Full-size URL list, aligned with thumbs (index 0 = featured). */
    var fullSrcs = thumbs.length
      ? thumbs.map(function (t) { return t.getAttribute('data-full-src') || t.getAttribute('data-thumb-src'); })
      : (mainImg ? [mainImg.getAttribute('data-full-src') || mainImg.src] : []);
    if (!fullSrcs.length) return;

    var index = 0;
    function currentIndex() {
      var active = $('.thumb.is-active', gallery);
      var i = thumbs.indexOf(active);
      return i > -1 ? i : index;
    }
    function show(i) {
      index = (i + fullSrcs.length) % fullSrcs.length;
      if (zoomImg) {
        zoomImg.src = fullSrcs[index];
        zoomImg.alt = (mainImg && mainImg.alt) || '';
      }
    }
    function open() {
      index = currentIndex();
      show(index);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = $('[data-zoom-close]', modal);
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    var main = $('[data-gallery-main]', gallery);
    if (main && main.hasAttribute('data-zoomable')) {
      main.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        open();
      });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
      main.setAttribute('tabindex', '0');
      main.setAttribute('role', 'button');
      main.setAttribute('aria-label', 'Zoom product image');
    }
    $all('[data-zoom-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && prevBtn) show(index - 1);
      else if (e.key === 'ArrowRight' && nextBtn) show(index + 1);
    });
  });

  /* ---------- 2. Radio-pill variant sync (buttons / swatch modes) ----------
     theme.js only syncs dropdown selects ([data-option-index]). In pill mode
     the radios carry data-option-radio instead, and this block mirrors the
     same UI updates: price, add-to-cart button, stock indicator, sticky bar. */
  $all('[data-product-form]').forEach(function (form) {
    var pillGroups = $all('[data-option-radio]', form);
    if (!pillGroups.length) return;
    var variantSelect = $('[data-variant-select]', form);
    var priceWrap = document.querySelector('[data-product-price]');
    var stockEl = document.querySelector('[data-stock-indicator]');
    var stockCount = stockEl ? $('[data-stock-count]', stockEl) : null;
    var stockThreshold = stockEl ? parseInt(stockEl.getAttribute('data-threshold') || '5', 10) : 5;
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var addBtn = $('[data-add-to-cart]', form);
    var addLabel = addBtn ? addBtn.textContent : 'Add to Bag';

    function chosenTitle() {
      return pillGroups.map(function (g) {
        var checked = $('input:checked', g);
        return checked ? checked.value : '';
      }).join(' / ');
    }
    function matchOption() {
      if (!variantSelect || !variantSelect.options) return null;
      var title = chosenTitle();
      for (var i = 0; i < variantSelect.options.length; i++) {
        if (variantSelect.options[i].text.trim() === title) return variantSelect.options[i];
      }
      return null;
    }
    function syncUI() {
      var opt = matchOption();
      if (!opt) return;
      variantSelect.value = opt.value;
      /* Price */
      if (priceWrap) {
        var price = opt.getAttribute('data-price');
        var compare = opt.getAttribute('data-compare');
        var html = '<span class="price-wrap">';
        if (compare && compare !== price) {
          html += '<s class="price-compare">' + compare + '</s>';
          html += '<span class="price price--sale">' + price + '</span>';
        } else {
          html += '<span class="price">' + price + '</span>';
        }
        html += '</span>';
        priceWrap.innerHTML = html;
      }
      /* Add to cart button */
      var available = opt.getAttribute('data-available') === 'true';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? addLabel : 'Sold Out';
      }
      /* Stock indicator */
      if (stockEl) {
        var tracked = opt.getAttribute('data-tracked') === 'true';
        var inv = parseInt(opt.getAttribute('data-inventory') || '0', 10);
        if (tracked && inv > 0 && inv <= stockThreshold) {
          if (stockCount) stockCount.textContent = String(inv);
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
      /* Sticky bar */
      if (stickyBar) {
        var vEl = $('[data-sticky-variant]', stickyBar);
        var pEl = $('[data-sticky-price]', stickyBar);
        var sAdd = $('[data-sticky-add]', stickyBar);
        if (vEl) vEl.textContent = opt.text.trim();
        if (pEl && opt.getAttribute('data-price')) pEl.textContent = opt.getAttribute('data-price');
        if (sAdd) {
          sAdd.setAttribute('data-variant-id', opt.value);
          sAdd.disabled = !available;
        }
      }
    }
    pillGroups.forEach(function (g) {
      g.addEventListener('change', syncUI);
    });
    syncUI();
  });

  /* ---------- 3. Share: copy link ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share-copy]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-copy') || window.location.href;
    function done() {
      btn.classList.add('is-copied');
      var original = btn.getAttribute('aria-label');
      btn.setAttribute('aria-label', 'Link copied');
      setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.setAttribute('aria-label', original || 'Copy link');
      }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () { fallback(); });
    } else {
      fallback();
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (err) { /* no-op */ }
      document.body.removeChild(ta);
    }
  });

  /* ---------- 4. Related products carousel ---------- */
  $all('[data-related-carousel]').forEach(function (car) {
    var track = $('[data-related-track]', car);
    if (!track) return;
    $all('[data-related-prev]', car).forEach(function (b) {
      b.addEventListener('click', function () {
        var card = $('.product-card', track);
        track.scrollBy({ left: -(card ? card.offsetWidth + 20 : 300), behavior: 'smooth' });
      });
    });
    $all('[data-related-next]', car).forEach(function (b) {
      b.addEventListener('click', function () {
        var card = $('.product-card', track);
        track.scrollBy({ left: (card ? card.offsetWidth + 20 : 300), behavior: 'smooth' });
      });
    });
  });

  /* ---------- 5. Cart drawer order note ----------
     The drawer's checkout is a plain link, so the note is saved via
     /cart/update.js on change and (again, safely) before checkout. */
  (function drawerNote() {
    var note = document.querySelector('[data-cart-note]');
    if (!note) return;
    var checkout = document.querySelector('[data-drawer-checkout]');
    function save() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {});
    }
    note.addEventListener('change', save);
    if (checkout) {
      checkout.addEventListener('click', function (e) {
        e.preventDefault();
        save().then(function () { window.location.href = checkout.getAttribute('href'); });
      });
    }
  })();
})();
